@if ({ row: columnData | async }; as $) {
  <div>
    @if ($.row && $.row.status.toLowerCase() == 'scheduled') {
      <button
        pButton
        pRipple
        type="button"
        icon="fa fa-check"
        class="p-button-rounded p-button-outlined p-0 w-2rem h-2rem text-sm mx-auto"
        (click)="SetOutComeDetails($.row)"
      ></button>
    }
    <!-- Selected State -->
    @if ($.row && $.row.status.toLowerCase() == 'completed') {
      <button
        pButton
        pRipple
        type="button"
        icon="fa fa-check"
        class="p-button-rounded p-0 w-2rem h-2rem text-sm mx-auto"
      ></button>
    }
    <!-- Selected State -->
    @if (showCallOutcomePopup) {
      <app-call-outcome
        [visible]="showCallOutcomePopup"
        (onHide)="closeDialog()"
        (onHide)="closeDialog()"
        [data]="outcomeDetail"
        (hideOutCome)="HideOutComePopup($event)"
        (showClientProfile)="GoToClientDetails($event)"
      />
    }
    @if (showMeetingOutcomePopup) {
      <app-tour-outcome
        [visible]="showMeetingOutcomePopup"
        (onHide)="closeDialog()"
        (onHide)="closeDialog()"
        [tourOutComeData]="outcomeDetail"
        (showClientProfile)="GoToClientDetails($event)"
        (hideOutCome)="HideOutComePopup($event)"
        [data]="$.row"
      />
    }
  </div>
}
